import { fetchPost, fetchPut, fetchGet, fetchDelete } from '@/utils/request'

export function getInvestments (query) {
    return fetchGet('/gateway/v1/investments', query)
}
export function getInvesHotline () { //获取招商加盟400大号
    return fetchGet('/gateway/v1/partner-customer-hotlines')
}
export function getInvesTelephone (query) { //获取招商加盟400分机号
    return fetchGet('/gateway/v1/partner-telephones', query)
}
export function editInvesTelephone (query) { //修改招商加盟400分机号
    return fetchPut('/gateway/v1/partner-telephones', query)
}
export function deleInvesTelephone (query) { //删除招商加盟400分机号
    return fetchDelete('/gateway/v1/partner-telephones', query)
}
export function addInvesTelephone (query) { //新增招商加盟400分机号
    return fetchPost('/gateway/v1/partner-telephones', query)
}
export function getInvesHotlineNum (query) { //获取招商加盟400分机号可用数量
    return fetchGet('/gateway/v1/partner-customer-hotlines/usable-telephones-count', query)
}
export function getRandomHotline() { //随机获取招商加盟400分机号
    return fetchGet('/gateway/v1/partner-customer-hotlines/random-telephone-number')
}
export function getFormChannels () {
    return fetchGet('/gateway/v1/form-channels')
}